// extracted by extract-css-chunks-webpack-plugin
module.exports = {"featuredItemGrid":"_2yMfZ9 aLs3Nr","headingWrapper":"_3jaMdt"};